import { useState, useEffect } from 'react';
import Alert from 'react-bootstrap/Alert';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import Spinner from 'react-bootstrap/Spinner';
import Table from 'react-bootstrap/Table';

import { getAdditionalEventPlaces } from '../../utils/api_requests.ts';
import baseConfig from '../../config/baseConfig.js';
import "./Registration.css"

function RegistrationInfo() {
    const [availablePlaces, setAvailablePlaces] = useState(null);
    const [placesError, setPlacesError] = useState(false);
    const [placesLoading, setPlacesLoading] = useState(true);

    useEffect(() => {
        getAdditionalEventPlaces()
            .then((response) => {
                if (response.success && response.data?.data) {
                    setAvailablePlaces(response.data.data.available);
                } else {
                    setPlacesError(true);
                }
            })
            .catch(() => setPlacesError(true))
            .finally(() => setPlacesLoading(false));
    }, []);


    return (
        <>
            <Card className="eventPrice">
                <Card.Header as="h4" className="eventPricesHeader">
                    <i className="bi bi-cash-coin"></i> Koszty udziału w Konferencji
                </Card.Header>
                <Card.Body>
                    <Card.Title>
                    </Card.Title>
                    <Card.Text as="div">
                        Udział w Konferencji jest płatny. Opłata wynosi <b>50 zł za rodzinę</b>.
                    </Card.Text>
                </Card.Body>
            </Card>

            <Card className="additionalEventPrice">
                <Card.Header as="h4" className="additionalEventPricesHeader">
                    <i className="bi bi-fork-knife"></i> Informacje o wydarzeniu towarzyszącym
                </Card.Header>
                <Card.Body>
                    <Card.Text>
                        Wydarzenie towarzyszące - wspólna kolacja po Konferencji.
                    </Card.Text>
                    <Card.Text className="additionalEventLocation">
                        <strong>Restauracja Campanile</strong><br />
                        <i className="bi bi-geo-alt-fill"></i> <a href="https://maps.app.goo.gl/G6mSK22eyvmbfcJA8" target="_blank">ul. Ślężna 26, 53-302 Wrocław</a></Card.Text>
                    <Card.Text className="additionalEventTime">Godzina i data: <strong>17:00, 9 maja 2026 r.</strong></Card.Text>
                    {baseConfig.displayRegistrationForm ? (
                        <Card.Text as="div">
                            <Alert variant="info">
                                Pozostało{' '}
                                {placesLoading ? (
                                    <Spinner animation="border" size="sm" />
                                ) : placesError ? (
                                    <span className="text-danger">– (brak danych)</span>
                                ) : (
                                    <b>{availablePlaces}</b>
                                )}{' '}
                                miejsc.
                            </Alert>
                        </Card.Text>
                    ) : null}
                    <Card.Text as="div">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Opcja</th>
                                    <th>Koszt</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Dorośli oraz dzieci powyżej 10 roku życia</td>
                                    <td>142 zł / osoba</td>
                                </tr>
                                <tr>
                                    <td>Dzieci w wieku 2-10 lat</td>
                                    <td>71 zł / osoba</td>
                                </tr>
                                <tr>
                                    <td>Dzieci w wieku 0-2 lat oraz karmione przez sondę / PEG</td>
                                    <td>Bezpłatnie</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Card.Text>
                    <Card.Text as="div">
                        W cenie kolacji: zupa, danie główne, deser, kawa / herbata.
                    </Card.Text>
                </Card.Body>
            </Card>

        </>
    );
}

export default RegistrationInfo;